import * as React from 'react';
import { useContext } from 'react';
import styled from '@emotion/styled';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LightBoxContext } from '../layers/LightBoxWidget';
import { ImageModel } from '../../core/models/ImageModel';

export type ImageMedia = {
  image?: ImageModel;
};

export type MediaIcon = ImageMedia & {
  name?: string;
  icon?: IconProp;
};

export interface MediaIconWidgetProps {
  media: MediaIcon;
  font_size?: number;
  className?: any;
  lightBox?: boolean;
}

export const MediaIconWidget: React.FC<MediaIconWidgetProps> = (props) => {
  const lightbox = useContext(LightBoxContext);
  if (props.media.image) {
    return (
      <S.Avatar
        onClick={() => {
          if (props.lightBox) {
            lightbox.setImage(props.media.image);
          }
        }}
        className={props.className}
        image={props.media.image}
      />
    );
  }
  if (props.media.name) {
    return (
      <S.Name className={props.className} font_size={props.font_size}>
        {props.media.name.substring(0, 1)}
      </S.Name>
    );
  }
  if (props.media.icon) {
    return <S.Icon className={props.className} font_size={props.font_size} icon={props.media.icon} />;
  }
  return null;
};
namespace S {
  export const Name = styled.div<{ font_size: number }>`
    background-color: #a514f7;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(p) => p.font_size}px;
    color: ${(p) => p.theme.text.primary};
    aspect-ratio: 1/1;
    font-family: Square, sans-serif;
  `;

  export const Avatar = styled.div<{ image: ImageModel }>`
    background-color: #a514f7;
    background-image: url('${(p) => p.image.url}');
    background-position: center center;
    background-size: cover;
    aspect-ratio: 1/1;
    cursor: pointer;
  `;

  export const Icon = styled(FontAwesomeIcon, {
    shouldForwardProp: (prop) => prop !== 'font_size'
  })<{ font_size?: number }>`
    font-size: ${(p) => p.font_size}px;
    opacity: 0.7;
  `;
}
